import React from 'react';

function Lock3Icon({ fill, ...restProps }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={fill ?? ''}
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M9.483 1.703A4.934 4.934 0 0 0 6.43 3.189c-.729.749-1.13 1.528-1.354 2.628-.033.163-.052.595-.065 1.44l-.019 1.207-.188.055c-1.016.294-1.878 1.177-2.136 2.19-.139.545-.151.766-.151 2.624 0 1.859.012 2.079.151 2.624.28 1.1 1.219 1.992 2.359 2.244.547.121 1.298.138 5.406.123 4.06-.014 4.135-.017 4.689-.159 1.027-.262 1.944-1.181 2.21-2.214.135-.523.15-.792.15-2.618 0-1.825-.015-2.094-.15-2.618-.154-.598-.572-1.234-1.074-1.634a3.558 3.558 0 0 0-1.062-.563l-.188-.054-.018-1.19c-.013-.87-.032-1.262-.069-1.457-.206-1.069-.651-1.915-1.403-2.67-.691-.693-1.427-1.107-2.361-1.33a4.863 4.863 0 0 0-1.674-.114m1.323 1.725a3.355 3.355 0 0 1 2.418 2.393c.086.319.089.363.101 1.421l.013 1.091H6.667v-.979c0-1.059.027-1.332.182-1.784.377-1.107 1.376-1.965 2.546-2.187.356-.067 1.07-.044 1.411.045m3.834 6.651c.381.1.758.396.973.761.192.328.203.462.203 2.493 0 1.627-.007 1.88-.057 2.096a1.561 1.561 0 0 1-1.153 1.161c-.24.056-.533.06-4.623.06-4.074 0-4.382-.004-4.597-.059a1.588 1.588 0 0 1-1.161-1.208c-.059-.284-.059-3.816 0-4.1.114-.549.566-1.047 1.075-1.184.082-.022.263-.052.4-.066.138-.014 2.155-.022 4.483-.019 3.924.006 4.25.011 4.457.065'
        fill-rule='evenodd'
        fill={fill ?? ''}
      />
    </svg>
  );
}

export default Lock3Icon;
